module.exports = {
      id: "banner_en-usage",
      viewBox: "0 0 104.831 104.279",
      url: __webpack_public_path__ + "images/js_src_vue/page_price_versions/sprite.ce6f763a.svg#banner_en-usage",
      toString: function () {
        return this.url;
      }
    }